import { Star } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { useEffect, useState, type FC } from "react";

type RatingStarsProps = {
  rating?: number;
  max?: number;
  className?: string;
  starClassName?: string;
  loading?: boolean;
  onChange?: (rating: number) => void;
};

export const RatingStars: FC<RatingStarsProps> = ({
  rating,
  max = 5,
  className = "",
  starClassName = "",
  loading = false,
  onChange,
}) => {
  const [animatedRating, setAnimatedRating] = useState(0);

  useEffect(() => {
    if (!loading) return;

    let current = 0;
    const interval = setInterval(() => {
      current = (current % max) + 1;
      setAnimatedRating(current);
    }, 100);

    return () => clearInterval(interval);
  }, [loading, max]);

  const displayedRating = loading ? animatedRating : rating || 0;

  return (
    <div className={twMerge("flex items-center", className)}>
      {Array.from({ length: max }, (_, i) => (
        <Star
          key={i + 1}
          className={twMerge(
            "mr-1 h-5 w-5 transition-all duration-200",
            starClassName,
            loading ? "text-gray-400" : "cursor-pointer text-secondary",
            i + 1 <= displayedRating
              ? "fill-current text-primary"
              : "fill-transparent stroke-primary/40",
          )}
          onClick={() => !loading && onChange?.(i + 1)}
        />
      ))}
    </div>
  );
};
